/*
 * @Author: zhu.huijun
 * @Date: 2021-05-18 14:23:12
 * @Last Modified by: zhu.huijun
 * @Last Modified time: 2022-02-24 14:52:03
 */

// c）具体字段映射：
// 语音模板：【servType】= 26 or 917
// Plan ID  ==>  SUBS_PLAN_ID
// Plan Name  ==>  SUBS_PLAN_NAME
// Plan Rental  ==>  PLAN_RENTAL
// Free Calls Per Month  ==>  FREE_CALLS_PER_MONTH

// Call Type  ==>  CALL_TYPE
// Connection Type  ==>  CONNECTIONTYPE
// Pulse  ==>  PULSE

// From No. of Calls  ==>  FROM_OF_CALLS
// To No. Of Calls  ==>  TO_OF_CALLS
// Charge Per Unit  ==>  CHARGE_PER_UNIT


// 宽带模板：【servType】= 79
// Tariff ID  ==>  SUBS_PLAN_ID
// Tariff Name  ==>  SUBS_PLAN_NAME
// Speed  ==>  SPEED
// Rental/Month  ==>  RENTAL_MONTH
// Annual Rental  ==>  ANNUAL_RENTAL
// Free Usage/MCU  ==>  FREE_USAGE_MCU
// Charges Beyond Free Limit  ==>  CHARGES_BEYOND_FREE
// Night Concession  ==>  NIGHT_CONCESSION
// Minimum Hire Month  ==>  MINIMUM_HIRE_MONTH
// Email Space(MB)  ==>  EMAIL_SPACE
// Free Static IP  ==>  FREE_STATIC_IP
// Additional Static IP Permit  ==>  ADDITIONAL_STATIC_IP

import React, { useEffect, useState } from 'react';
import { i18n } from 'fishx';
import { connect } from 'react-redux';

import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';

import { Row, Col, Table } from '@whalecloud/fdx';
import CommonModal from '@/components/CommonModal';

import styles from './index.module.less';

const PlanDetail = props => {
  const { cardInfo = {}, servType, onCancel, dispatch } = props;
  const [subsPlanDesc, setSubsPlanDesc] = useState({});

  useEffect(() => {
    if (cardInfo.offerId) {
      dispatch({
        type: 'selectPlan/qrySubsPlanDesc',
        payload: cardInfo.offerId,
      }).then(res => setSubsPlanDesc(get(res, 'zsmart.Data') || {}));
    }
  }, [cardInfo]);

  const getTableData = data => { // 一个不应该让前端兼容的数据，非要前端兼容，严重怀疑后端的开发能力
    if (isEmpty(data)) {
      return [];
    }
    return Array.isArray(data) ? data : [data];
  };

  const planFormItems = () => {
    if (`${servType}` === '79') { // 宽带信息模板展示
      return [{
        label: 'TARIFF_ID',
        value: subsPlanDesc.SUBS_PLAN_ID,
      }, {
        label: 'TARIFF_Name',
        value: subsPlanDesc.SUBS_PLAN_NAME,
      }, {
        label: 'SPEED',
        value: subsPlanDesc.SPEED,
      }, {
        label: 'RENTAL_MONTH',
        value: subsPlanDesc.RENTAL_MONTH,
      }, {
        label: 'ANNUAL_RENTAL',
        value: subsPlanDesc.ANNUAL_RENTAL,
      }, {
        label: 'FREE_USAGE_MCU',
        value: subsPlanDesc.FREE_USAGE_MCU,
      }, {
        label: 'CHARGES_BEYOND_FREE',
        value: subsPlanDesc.CHARGES_BEYOND_FREE,
      }, {
        label: 'NIGHT_CONCESSION',
        value: subsPlanDesc.NIGHT_CONCESSION,
      }, {
        label: 'MINIMUM_HIRE_MONTH',
        value: subsPlanDesc.MINIMUM_HIRE_MONTH,
      }, {
        label: 'EMAIL_SPACE',
        value: subsPlanDesc.EMAIL_SPACE,
      }, {
        label: 'FREE_STATIC_IP',
        value: subsPlanDesc.FREE_STATIC_IP,
      }, {
        label: 'ADDITIONAL_STATIC_IP',
        value: subsPlanDesc.ADDITIONAL_STATIC_IP,
      }];
    }
    // 语音信息模板展示
    return [{
      label: 'SUBS_PLAN_ID', // SUBS_PLAN_ID
      value: subsPlanDesc.SUBS_PLAN_ID,
    }, {
      label: 'SUBS_PLAN_NAME',
      value: subsPlanDesc.SUBS_PLAN_NAME,
    }, {
      label: 'PLAN_RENTAL',
      value: subsPlanDesc.PLAN_RENTAL,
    }, {
      label: 'FREE_CALLS_PER_MONTH',
      value: subsPlanDesc.FREE_CALLS_PER_MONTH,
    }];
  };

  const tableRender = text => text || '-';

  const pulseColumns = [
    {
      title: i18n('CALL_TYPE'),
      dataIndex: 'CALL_TYPE',
      key: 'CALL_TYPE',
      render: tableRender,
    },
    {
      title: i18n('CONNECTIONTYPE'),
      dataIndex: 'CONNECTIONTYPE',
      key: 'CONNECTIONTYPE',
      render: tableRender,
    },
    {
      title: i18n('PULSE'),
      dataIndex: 'PULSE',
      key: 'PULSE',
      render: tableRender,
    },
  ];

  const callRateColumns = [
    {
      title: i18n('FROM_OF_CALLS'),
      dataIndex: 'FROM_OF_CALLS',
      key: 'FROM_OF_CALLS',
      render: tableRender,
    },
    {
      title: i18n('TO_OF_CALLS'),
      dataIndex: 'TO_OF_CALLS',
      key: 'TO_OF_CALLS',
      render: tableRender,
    },
    {
      title: i18n('CHARGE_PER_UNIT'),
      dataIndex: 'CHARGE_PER_UNIT',
      key: 'CHARGE_PER_UNIT',
      render: tableRender,
    },
  ];
  
  const renderForm = () => (
    <Row type="flex" className={styles.formGroup}>
      {
        planFormItems().map(({ label, value }) => (
          <Col className={styles.formItem} span={12} key={label}>
            <Row type="flex">
              <Col span={12}>
                <span className={styles.label}>{i18n(label)}</span>
              </Col>
              <Col span={12}>
                <span className={styles.value}>{value || '-'}</span>
              </Col>
            </Row>
          </Col>
        ))
      }
    </Row>
  );
  return (
    <CommonModal
      modalOpts={{
        title: 'Plan Details',
        footer: null,
        draggable: false,
        onCancel,
        width: 950,
      }}
    >
      {
        servType === '79' && (
          <div className={`threeColumnWrap ${styles.offerDetail}`}>{renderForm()}</div>
        )
      }
      {
        ['26', '917'].includes(servType) && (
          <div className={`threeColumnWrap ${styles.offerDetail}`}>
            <h4 className="blockSubTitle">{i18n('PLANS_TITLE')}</h4>
            { renderForm() }
            <h4 className="blockSubTitle">{i18n('PLAN_PULSE')}</h4>
            <Table dataSource={getTableData(subsPlanDesc.PLAN_PULSE_LIST)} columns={pulseColumns} />
            <h4 className="blockSubTitle">{i18n('CALL_RATE')}</h4>
            <Table dataSource={getTableData(subsPlanDesc.CALL_RATE_LIST)} columns={callRateColumns} />
          </div>
        )
      }
    </CommonModal>
  );
};

export default connect()(PlanDetail);
